import { all } from "redux-saga/effects";
import authSaga from "./AuthSaga";
import selfSaga from "./SelfSaga";
import userSaga from "./UserSaga";
import roleSage from "./RoleSaga";
import enterpriseSaga from "./EnterpriseSaga";
import learningObjectSaga from "./LearningObjectSaga";
import learningMilestoneSaga from "./LearningMilestoneSaga";
import learningPathwaySaga from "./LearningPathwaySaga";
import uploadSaga from "./UploadSaga";
import audienceSaga from "./AudienceSaga";
import customFieldSaga from "./CustomFieldSaga";
import reportSaga from "./ReportSaga";
import notificationSaga from "./NotificationSaga";
import certificateSaga from "./CertificateSaga";
import rewardSaga from "./RewardSaga";
import registrationSaga from "./RegistrationSaga";
import integrationSaga from "./IntegrationSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    enterpriseSaga(),
    learningMilestoneSaga(),
    learningObjectSaga(),
    learningPathwaySaga(),
    roleSage(),
    selfSaga(),
    uploadSaga(),
    userSaga(),
    audienceSaga(),
    customFieldSaga(),
    reportSaga(),
    notificationSaga(),
    certificateSaga(),
    rewardSaga(),
    registrationSaga(),
    integrationSaga(),
  ]);
}
